import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { Observable, map } from 'rxjs';
import { BajaDiaInhabilcommand, GetDiasInhabilesFiltradosQuery, RegDiaInhabilcommand, UpdDiaInhabilcommand } from '../../commons/class/diaInhabil.class';
import { Documents } from '../../commons/class/archivo.inteface';
import { ENV_TOKEN } from '../../app-module.token';


@Injectable({
  providedIn: 'root'
})
export class ConfigDiaInhabilService {

  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;

  readonly environment = inject(ENV_TOKEN);
  private httpService: HttpService = inject(HttpService);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Obtiene los días inhabiles activos para un tipo de organización específico
   * @param idTipoOrg 
   * @returns 
   */
  getDiasInhabilesActivos(idTipoOrg: number): Observable<any> {
    const funcion = "icoij/getNonWorkingDays";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene los días inhabiles filtrados según los parámetros proporcionados
   * @param request 
   * @returns 
   */
  getDiasInhabilesFiltrados(request: GetDiasInhabilesFiltradosQuery): Observable<any> {
    const funcion = "icoij/getNonWorkingDaysFilter";
    const ruta = `${this.urlRaiz}/${funcion}/${request.TipoOrganismoIdIOJ}/${request.Estado}/${request.FechaInicio}/${request.FechaFin}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Crea un nuevo día inhabil
   * @param request 
   * @returns 
   */
  CreateDiaInhabil(request: RegDiaInhabilcommand) {
    const funcion = "icoij/CreateNonWorkingDay";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Actualiza un día inhabil existente
   * @param request 
   * @returns 
   */
  UpdateDiaInhabil(request: UpdDiaInhabilcommand) {
    // console.log('service-update')
    // console.log(request)
    const funcion = "icoij/UpdateNonWorkingDay";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }


  /**
   * Elimina un día inhabil existente
   * @param request 
   * @returns 
   */
  DeleteDiaInhabil(request: BajaDiaInhabilcommand) {
    const funcion = "icoij/deleteNonWorkingDay";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.putRequestBody(ruta, request)
  }

  /**
   * Obtiene los documentos asociados a un registro de día inhabil específico, se construye la ruta para la consulta utilizando el ID de configuración del día inhabil, se hace una petición GET al servicio utilizando la ruta construida, se procesa la respuesta para extraer los documentos y se retorna un Observable con el arreglo de documentos
   * @param idConfiguracion 
   * @returns 
   */
  obtenerDocumentoRegistroDiaInhabil(
    idConfiguracion: number
  ): Observable<Documents[]> {
    const url = `oaj.icoij.gateway/icoij/getDocumentosByIdTrans/${idConfiguracion}/239`;
    return this.httpService.getRequest(url).pipe(
      map((resp: any) => {
        if (resp?.succcess) {
          if (Array.isArray(resp.data)) {
            return resp.data as Documents[];
          }
          if (resp.data?.$values && Array.isArray(resp.data.$values)) {
            return resp.data.$values as Documents[];
          }
        }
        return [] as Documents[];
      })
    ) as Observable<Documents[]>;
  }

}